import Vue from "vue";
import methods from './global-methods';

const globalMethods = methods;

Vue.mixin({
  methods: globalMethods,
  watch: {
    isLoading: function (val) {
      if (val) {
        this.formLoader();
      } else {
        this.formHideLoader();
      }
    },
    '$route.name'() {
      this.setTitle(this.$t(this.$route.name + '.title'));
    }
  }
});

export default methods;
